/**
 * Symbols for drawing the axes on the graph.
 */
export const AXIS = {
  n: '▲', // Symbol for the top end of the Y-axis
  ns: '│', // Vertical line for the Y-axis
  y: '┤', // Right tick mark on the Y-axis
  nse: '└', // Bottom corner for the Y-axis meeting the X-axis
  x: '┬', // Top tick mark on the X-axis
  we: '─', // Horizontal line for the X-axis
  e: '▶', // Arrow symbol for the end of the X-axis
  intersectionXY: '┼', // Intersection of the X and Y axes
  intersectionX: '┴', // Bottom tick mark on the X-axis
  intersectionY: '├', // Left tick mark on the Y-axis
};

/**
 * Symbols for rendering chart elements, including lines and areas.
 */
export const CHART = {
  we: '━', // Bold horizontal line in the chart
  wns: '┓', // Top-right corner for vertical-to-horizontal connection
  ns: '┃', // Bold vertical line in the chart
  nse: '┗', // Bottom-left corner for vertical-to-horizontal connection
  wsn: '┛', // Bottom-right corner for vertical-to-horizontal connection
  sne: '┏', // Top-left corner for vertical-to-horizontal connection
  area: '█', // Filled area symbol for chart representation
};

/**
 * Symbol representing an empty space on the graph.
 */
export const EMPTY = ' ';

/**
 * Symbols for drawing thresholds on the graph.
 */
export const THRESHOLDS = {
  x: '━', // Symbol for horizontal threshold line
  y: '┃', // Symbol for vertical threshold line
};

/**
 * Symbol for the point of the graph.
 */
export const POINT = '●';

/**
 * Layout and formatting constants
 */
export const LAYOUT = {
  MIN_PLOT_HEIGHT: 3,
  DEFAULT_DECIMAL_PLACES: 3,
  K_FORMAT_THRESHOLD: 1000,
  DEFAULT_PADDING: 2,
  DEFAULT_Y_SHIFT_OFFSET: 1,
} as const;
